import { usePageSet } from "src/hooks/pageSet";
import {
  ConditionalPageProp,
  PageSetConfigProps,
  PageSetPageConfigProps,
} from "@pageDefinitions/types";
import { conditionsPass } from "@pageDefinitions/conditions";
import getStore from "@utils/redux/store";

export function evalConditionalPageProp<T>(
  prop: ConditionalPageProp<T> | undefined,
  state = getStore().getState()
): T | undefined {
  if (prop === undefined) {
    return undefined;
  }

  if (typeof prop === "object" && "cases" in prop) {
    return (
      prop.cases.find((c) => conditionsPass(c.conditions, state).score > 0)
        ?.value || prop.default
    );
  }

  return prop;
}

export function useActivePageProps(): PageSetPageConfigProps {
  const { activePage } = usePageSet();

  return activePage?.props || {};
}

export function useActivePageSetProps(): PageSetConfigProps {
  const { activePageSet } = usePageSet();

  return activePageSet?.props || {};
}
